import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatHorizontalStepper, MatStep } from '@angular/material';
import { CallModel } from 'src/app/shared/models/calllog.model';
import { CommunicationService } from 'src/app/shared/services/communication.service';

@Component({
  selector: 'app-finish-step',
  templateUrl: './finish-step.component.html',
  styleUrls: ['./finish-step.component.css']
})
export class FinishStepComponent implements OnInit {
  @Input() call : CallModel;
  //@Input() stepper : MatHorizontalStepper;
  //@Input() mystep : MatStep;
  @Output() onFinishStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBackThirdStep: EventEmitter<any> = new EventEmitter<any>();

  //issue : string;
  //solution : string;
  note : string;
  constructor(private commservice : CommunicationService) { }

  ngOnInit() {
   // this.issue = "dfadfdasfas";
   // this.solution = "adfasfasfasdfasdfdasfadfasdfasfasfdasfdasfasfasdfadfasdfasdfadsfasdfasdfasdfdasfasdfadsfasdfdas";
  }

  onFinish()
  {   
    console.log("onFinish");

    this.call.isEnd = true;
   // this.mystep.completed = true;
   // this.stepper.reset();
    this.call.callLog.note = this.note;
   // this.commservice.sendCallStatus(this.call);

    this.onFinishStep.emit(this.call);
    this.note = "";
  }

  onBack()
  {   
   // this.mystep.completed = false;
  //  this.stepper.previous();

    this.onBackThirdStep.emit();
  }


}
